import noUiSlider from 'nouislider';
import {trans} from '../../functions';
import {collapseFilters} from './index/helpers';

export default {
    props: [
        'initialQuery',
        'initialBrandName',
        'initialBrandBanner',
        'initialBrandLogo',
        'initialBrandPresentation',
        'initialBrandSlug',
        'initialCategoryName',
        'initialCategoryPresentation',
        'initialCategoryBanner',
        'initialCategorySlug',
        'initialTagName',
        'initialTagSlug',
        'initialAttribute',
        'maxPrice',
        'initialSort',
        'initialPerPage',
        'initialPage',
        'initialViewMode',
        'initialPromotions',
        'initialFromPrice',
        'initialToPrice',
        'initialInStock',
    ],

    data() {
        return {
            fetchingProducts: false,
            emptyFilters: false,
            products: { data: [] },
            attributeFilters: [],
            brandBanner: this.initialBrandBanner,
            brandLogo: this.initialBrandLogo,
            brandPresentation: this.initialBrandPresentation,
            categoryName: this.initialCategoryName,
            categoryPresentation: this.initialCategoryPresentation,
            categoryBanner: this.initialCategoryBanner,
            viewMode: this.initialViewMode,
            queryParams: {
                query: this.initialQuery,
                brand: this.initialBrandSlug,
                category: this.initialCategorySlug,
                tag: this.initialTagSlug,
                attribute: this.initialAttribute || {},
                fromPrice: this.initialFromPrice || 0,
                toPrice: this.initialToPrice || this.maxPrice,
                sort: this.initialSort,
                perPage: this.initialPerPage,
                page: this.initialPage,
                promotions: this.initialPromotions,
                in_stock: this.initialInStock || 0,
            },
        };
    },

    watch: {
        viewMode() {
            this.syncUrl();
        },
    },

    computed: {
        emptyProducts() {
            return this.products.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.products.total / this.queryParams.perPage);
        },

        showingResults() {
            if (this.emptyProducts) {
                return;
            }

            return trans('storefront::products.showing_results', {
                from: this.products.from,
                to: this.products.to,
                total: this.products.total,
            });
        },
    },

    mounted() {
        this.addEventListeners();
        this.initPriceFilter();
        this.fetchProducts();
    },

    methods: {
        addEventListeners() {
            $(this.$refs.sortSelect).on('change', (e) => {
                this.queryParams.sort = e.currentTarget.value;

                this.fetchProducts();
            });

            $(this.$refs.perPageSelect).on('change', (e) => {
                this.queryParams.perPage = e.currentTarget.value;

                this.fetchProducts();
            });
        },

        initPriceFilter() {
            noUiSlider.create(this.$refs.priceRange, {
                connect: true,
                direction: window.FleetCart.rtl ? 'rtl' : 'ltr',
                start: [this.queryParams.fromPrice, this.queryParams.toPrice],
                range: {
                    min: [0],
                    max: [this.maxPrice],
                },
            });

            this.$refs.priceRange.noUiSlider.on('update', (values, handle) => {
                let value = Math.round(values[handle]);

                if (handle === 0) {
                    this.queryParams.fromPrice = value;
                } else {
                    this.queryParams.toPrice = value;
                }
            });

            this.$refs.priceRange.noUiSlider.on('change', this.fetchProducts);
        },

        updatePriceRange(fromPrice, toPrice) {
            this.$refs.priceRange.noUiSlider.set([fromPrice, toPrice]);

            this.fetchProducts();
        },

        toggleAttributeFilter(slug, value) {
            if (! this.queryParams.attribute.hasOwnProperty(slug)) {
                this.queryParams.attribute[slug] = [];
            }

            if (this.queryParams.attribute[slug].includes(value)) {
                this.queryParams.attribute[slug].splice(
                    this.queryParams.attribute[slug].indexOf(value),
                    1
                );
            } else {
                this.queryParams.attribute[slug].push(value);
            }

            this.fetchProducts({ updateAttributeFilters: false });
        },

        isFilteredByAttribute(slug, value) {
            if (! this.queryParams.attribute.hasOwnProperty(slug)) {
                return false;
            }

            return this.queryParams.attribute[slug].includes(value);
        },

        changeCategory(category) {
            this.categoryName = category.name;
            this.categoryBanner = category.banner.path;
            this.queryParams.query = null;
            this.queryParams.category = category.slug;
            this.queryParams.attribute = {};
            this.queryParams.page = 1;

            this.fetchProducts();
        },

        changePage(page) {
            this.queryParams.page = page;

            this.fetchProducts();
        },

        fetchProducts(options = { updateAttributeFilters: true }) {
            this.fetchingProducts = true;
            this.emptyFilters = !Object.entries(this.queryParams.attribute).some(item => item[1].length > 0);

            $.ajax({
                url: route('products.index', this.queryParams),
            }).then((response) => {
                this.products = response.products;

                if (options.updateAttributeFilters) {
                    this.attributeFilters = response.attributes;
                    this.$nextTick(() => {
                        collapseFilters();
                    });
                }

                this.scrollTopSearch(document.getElementById('product-search-wrap'));

                this.syncUrl();

            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingProducts = false;
            });
        },

        /**
         * Mirror the current filters into the URL (without reloading) so a
         * refresh or the browser back button restores the same results.
         */
        syncUrl() {
            const defaults = {
                fromPrice: 0,
                toPrice: this.maxPrice,
                sort: 'latest',
                perPage: 24,
                page: 1,
                in_stock: 0,
            };

            const params = {};

            Object.entries(this.queryParams).forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }

                if (typeof value === 'object' && Object.values(value).every((v) => !v || v.length === 0)) {
                    return;
                }

                if (defaults.hasOwnProperty(key) && String(value) === String(defaults[key])) {
                    return;
                }

                params[key] = value;
            });

            if (this.viewMode !== 'grid') {
                params.viewMode = this.viewMode;
            }

            const queryString = $.param(params);
            const url = window.location.pathname + (queryString ? `?${queryString}` : '');

            window.history.replaceState(null, '', url);
        },
        scrollTopSearch(element) {
            let headerOffset = 110;
            let elementPosition = element.getBoundingClientRect().top;
            let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        },
    },
};
